import { useCallback } from 'react';
import type { LensCorrectionValue } from '../../lib/filters/lens-correction';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Lens Correction panel — single signed slider. Negative =
 *  pincushion, positive = barrel. */
export function LensCorrectionPanel({
  value,
  onChange,
}: AdjustmentPanelProps<LensCorrectionValue>) {
  const set = useCallback(
    (patch: Partial<LensCorrectionValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Distortion"
        min={-100}
        max={100}
        step={1}
        value={value.amount}
        onChange={(v) => set({ amount: v })}
      />
    </div>
  );
}
